/**
 * Default localized text (US English).
 */
export type Locale = Partial<typeof locale>

const locale = {
  optional: "Optional",
  required: "Required",
  readonly: "Read-Only"
}

export default locale
